import React from 'react';
import { CheckIcon } from 'lucide-react';
const steps = ['Datos', 'Pago', 'Acceso'];
export function CheckoutSteps({
  current
}: {
  current: number;
}) {
  return <ol className="flex items-center gap-3" aria-label="Progreso del pedido" data-id="element-17" data-mp="2vmej8yusn7la">
      {steps.map((label, i) => {
      const done = i < current;
      const active = i === current;
      return <li key={label} className="flex items-center gap-3" data-id="element-18" data-mp="2lsfh3zupzntc" data-mpi={i}>
            <span className="flex items-center gap-2" data-id="element-19" data-mp="39kw2aj9r7vwv">
              <span className={`grid h-6 w-6 place-items-center rounded-full text-[11px] font-bold ${done ? 'bg-gold text-navy-deep' : active ? 'bg-navy-deep text-paper' : 'bg-navy-deep/10 text-navy/45'}`} data-id="element-20" data-mp="3ej60z3uoten8">
                {done ? <CheckIcon className="h-3.5 w-3.5" data-id="element-21" data-mp="1o94eqqhar6b8" /> : i + 1}
              </span>
              <span className={`text-xs font-semibold uppercase tracking-[0.12em] ${active || done ? 'text-navy-deep' : 'text-navy/40'}`} data-id="element-22" data-mp="1t7nxyj4ia3zw">
                {label}
              </span>
            </span>
            {i < steps.length - 1 && <span className="h-px w-6 bg-navy-deep/15" aria-hidden="true" data-id="element-23" data-mp="2nzi1snxrg58b" />}
          </li>;
    })}
    </ol>;
}